import { LocalDate } from '../../../../models';
export interface ShipmentArrivalDatesModel {
  actualArrivalTime: LocalDate | null;
  estimatedArrivalTime: LocalDate | null;
  plannedArrivalTime: LocalDate | null;
}
